import type { PrivacySettingToggles } from '@prisjakt/web-app-config/dist/markets/types';

const acceptCookies = (
  version: string,
  privacySettings?: PrivacySettingToggles,
  isLoggedIn?: boolean,
  showSuccessPrompt?: boolean
) =>
  ({
    type: 'ACCEPT_COOKIES',
    version,
    privacySettings,
    isLoggedIn,
    showSuccessPrompt,
  } as const);

export default acceptCookies;
